// extracted by mini-css-extract-plugin
export var container = "dD_g";
export var fadeDiv = "dD_gZ";
export var placeholderWrapper = "dD_rz";
export var video = "dD_rB";
export var videoWrapper = "dD_hL";
export var vimeoPlayer = "dD_rC";
export var wrapper = "dD_F";